/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as LayoutImport } from './routes/_layout'
import { Route as IndexImport } from './routes/index'
import { Route as LoginIndexImport } from './routes/login/index'
import { Route as LayoutSustainabilityImport } from './routes/_layout/sustainability'
import { Route as LayoutDataManagementImport } from './routes/_layout/data-management'
import { Route as LayoutDashboardImport } from './routes/_layout/dashboard'
import { Route as LayoutBillingAndPaymentsImport } from './routes/_layout/billing-and-payments'
import { Route as LayoutAnalyticsImport } from './routes/_layout/analytics'
import { Route as LayoutActiveManagementImport } from './routes/_layout/active-management'
import { Route as LayoutSustainabilityIndexImport } from './routes/_layout/sustainability/index'
import { Route as LayoutReportingIndexImport } from './routes/_layout/reporting/index'
import { Route as LayoutDataManagementIndexImport } from './routes/_layout/data-management/index'
import { Route as LayoutBillingAndPaymentsIndexImport } from './routes/_layout/billing-and-payments/index'
import { Route as LayoutAnalyticsIndexImport } from './routes/_layout/analytics/index'
import { Route as LayoutActiveManagementIndexImport } from './routes/_layout/active-management/index'
import { Route as LayoutSustainabilityTotalEmissionsImport } from './routes/_layout/sustainability/total-emissions'
import { Route as LayoutSustainabilityGhgEmissionsReportImport } from './routes/_layout/sustainability/ghg-emissions-report'
import { Route as LayoutSustainabilityElectricityMixUsageImport } from './routes/_layout/sustainability/electricity-mix-usage'
import { Route as LayoutReportingReportIdImport } from './routes/_layout/reporting/$reportId'
import { Route as LayoutInvoicesInvoiceIdImport } from './routes/_layout/invoices.$invoiceId'
import { Route as LayoutDataManagementInvoiceDataImport } from './routes/_layout/data-management/invoice-data'
import { Route as LayoutDataManagementEnergySourcingAndContractsImport } from './routes/_layout/data-management/energy-sourcing-and-contracts'
import { Route as LayoutBillingAndPaymentsPayablesSummaryImport } from './routes/_layout/billing-and-payments/payables-summary'
import { Route as LayoutAnalyticsUsageAndCostImport } from './routes/_layout/analytics/usage-and-cost'
import { Route as LayoutAnalyticsBenchmarkingImport } from './routes/_layout/analytics/benchmarking'
import { Route as LayoutActiveManagementIntervalImport } from './routes/_layout/active-management/interval'
import { Route as LayoutActiveManagementActiveEnergyManagementImport } from './routes/_layout/active-management/active-energy-management'
import { Route as LayoutReportingReportIdIndexImport } from './routes/_layout/reporting/$reportId/index'
import { Route as LayoutReportingReportIdEditImport } from './routes/_layout/reporting/$reportId/edit'

// Create/Update Routes

const LayoutRoute = LayoutImport.update({
  id: '/_layout',
  getParentRoute: () => rootRoute,
} as any)

const IndexRoute = IndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRoute,
} as any)

const LoginIndexRoute = LoginIndexImport.update({
  id: '/login/',
  path: '/login/',
  getParentRoute: () => rootRoute,
} as any)

const LayoutSustainabilityRoute = LayoutSustainabilityImport.update({
  id: '/sustainability',
  path: '/sustainability',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutDataManagementRoute = LayoutDataManagementImport.update({
  id: '/data-management',
  path: '/data-management',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutDashboardRoute = LayoutDashboardImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutBillingAndPaymentsRoute = LayoutBillingAndPaymentsImport.update({
  id: '/billing-and-payments',
  path: '/billing-and-payments',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutAnalyticsRoute = LayoutAnalyticsImport.update({
  id: '/analytics',
  path: '/analytics',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutActiveManagementRoute = LayoutActiveManagementImport.update({
  id: '/active-management',
  path: '/active-management',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutSustainabilityIndexRoute = LayoutSustainabilityIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => LayoutSustainabilityRoute,
} as any)

const LayoutReportingIndexRoute = LayoutReportingIndexImport.update({
  id: '/reporting/',
  path: '/reporting/',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutDataManagementIndexRoute = LayoutDataManagementIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => LayoutDataManagementRoute,
} as any)

const LayoutBillingAndPaymentsIndexRoute =
  LayoutBillingAndPaymentsIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => LayoutBillingAndPaymentsRoute,
  } as any)

const LayoutAnalyticsIndexRoute = LayoutAnalyticsIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => LayoutAnalyticsRoute,
} as any)

const LayoutActiveManagementIndexRoute =
  LayoutActiveManagementIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => LayoutActiveManagementRoute,
  } as any)

const LayoutSustainabilityTotalEmissionsRoute =
  LayoutSustainabilityTotalEmissionsImport.update({
    id: '/total-emissions',
    path: '/total-emissions',
    getParentRoute: () => LayoutSustainabilityRoute,
  } as any)

const LayoutSustainabilityGhgEmissionsReportRoute =
  LayoutSustainabilityGhgEmissionsReportImport.update({
    id: '/ghg-emissions-report',
    path: '/ghg-emissions-report',
    getParentRoute: () => LayoutSustainabilityRoute,
  } as any)

const LayoutSustainabilityElectricityMixUsageRoute =
  LayoutSustainabilityElectricityMixUsageImport.update({
    id: '/electricity-mix-usage',
    path: '/electricity-mix-usage',
    getParentRoute: () => LayoutSustainabilityRoute,
  } as any)

const LayoutReportingReportIdRoute = LayoutReportingReportIdImport.update({
  id: '/reporting/$reportId',
  path: '/reporting/$reportId',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutInvoicesInvoiceIdRoute = LayoutInvoicesInvoiceIdImport.update({
  id: '/invoices/$invoiceId',
  path: '/invoices/$invoiceId',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutDataManagementInvoiceDataRoute =
  LayoutDataManagementInvoiceDataImport.update({
    id: '/invoice-data',
    path: '/invoice-data',
    getParentRoute: () => LayoutDataManagementRoute,
  } as any)

const LayoutDataManagementEnergySourcingAndContractsRoute =
  LayoutDataManagementEnergySourcingAndContractsImport.update({
    id: '/energy-sourcing-and-contracts',
    path: '/energy-sourcing-and-contracts',
    getParentRoute: () => LayoutDataManagementRoute,
  } as any)

const LayoutBillingAndPaymentsPayablesSummaryRoute =
  LayoutBillingAndPaymentsPayablesSummaryImport.update({
    id: '/payables-summary',
    path: '/payables-summary',
    getParentRoute: () => LayoutBillingAndPaymentsRoute,
  } as any)

const LayoutAnalyticsUsageAndCostRoute =
  LayoutAnalyticsUsageAndCostImport.update({
    id: '/usage-and-cost',
    path: '/usage-and-cost',
    getParentRoute: () => LayoutAnalyticsRoute,
  } as any)

const LayoutAnalyticsBenchmarkingRoute =
  LayoutAnalyticsBenchmarkingImport.update({
    id: '/benchmarking',
    path: '/benchmarking',
    getParentRoute: () => LayoutAnalyticsRoute,
  } as any)

const LayoutActiveManagementIntervalRoute =
  LayoutActiveManagementIntervalImport.update({
    id: '/interval',
    path: '/interval',
    getParentRoute: () => LayoutActiveManagementRoute,
  } as any)

const LayoutActiveManagementActiveEnergyManagementRoute =
  LayoutActiveManagementActiveEnergyManagementImport.update({
    id: '/active-energy-management',
    path: '/active-energy-management',
    getParentRoute: () => LayoutActiveManagementRoute,
  } as any)

const LayoutReportingReportIdIndexRoute =
  LayoutReportingReportIdIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => LayoutReportingReportIdRoute,
  } as any)

const LayoutReportingReportIdEditRoute =
  LayoutReportingReportIdEditImport.update({
    id: '/edit',
    path: '/edit',
    getParentRoute: () => LayoutReportingReportIdRoute,
  } as any)

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexImport
      parentRoute: typeof rootRoute
    }
    '/_layout': {
      id: '/_layout'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof LayoutImport
      parentRoute: typeof rootRoute
    }
    '/_layout/active-management': {
      id: '/_layout/active-management'
      path: '/active-management'
      fullPath: '/active-management'
      preLoaderRoute: typeof LayoutActiveManagementImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/analytics': {
      id: '/_layout/analytics'
      path: '/analytics'
      fullPath: '/analytics'
      preLoaderRoute: typeof LayoutAnalyticsImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/billing-and-payments': {
      id: '/_layout/billing-and-payments'
      path: '/billing-and-payments'
      fullPath: '/billing-and-payments'
      preLoaderRoute: typeof LayoutBillingAndPaymentsImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/dashboard': {
      id: '/_layout/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof LayoutDashboardImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/data-management': {
      id: '/_layout/data-management'
      path: '/data-management'
      fullPath: '/data-management'
      preLoaderRoute: typeof LayoutDataManagementImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/sustainability': {
      id: '/_layout/sustainability'
      path: '/sustainability'
      fullPath: '/sustainability'
      preLoaderRoute: typeof LayoutSustainabilityImport
      parentRoute: typeof LayoutImport
    }
    '/login/': {
      id: '/login/'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginIndexImport
      parentRoute: typeof rootRoute
    }
    '/_layout/active-management/active-energy-management': {
      id: '/_layout/active-management/active-energy-management'
      path: '/active-energy-management'
      fullPath: '/active-management/active-energy-management'
      preLoaderRoute: typeof LayoutActiveManagementActiveEnergyManagementImport
      parentRoute: typeof LayoutActiveManagementImport
    }
    '/_layout/active-management/interval': {
      id: '/_layout/active-management/interval'
      path: '/interval'
      fullPath: '/active-management/interval'
      preLoaderRoute: typeof LayoutActiveManagementIntervalImport
      parentRoute: typeof LayoutActiveManagementImport
    }
    '/_layout/analytics/benchmarking': {
      id: '/_layout/analytics/benchmarking'
      path: '/benchmarking'
      fullPath: '/analytics/benchmarking'
      preLoaderRoute: typeof LayoutAnalyticsBenchmarkingImport
      parentRoute: typeof LayoutAnalyticsImport
    }
    '/_layout/analytics/usage-and-cost': {
      id: '/_layout/analytics/usage-and-cost'
      path: '/usage-and-cost'
      fullPath: '/analytics/usage-and-cost'
      preLoaderRoute: typeof LayoutAnalyticsUsageAndCostImport
      parentRoute: typeof LayoutAnalyticsImport
    }
    '/_layout/billing-and-payments/payables-summary': {
      id: '/_layout/billing-and-payments/payables-summary'
      path: '/payables-summary'
      fullPath: '/billing-and-payments/payables-summary'
      preLoaderRoute: typeof LayoutBillingAndPaymentsPayablesSummaryImport
      parentRoute: typeof LayoutBillingAndPaymentsImport
    }
    '/_layout/data-management/energy-sourcing-and-contracts': {
      id: '/_layout/data-management/energy-sourcing-and-contracts'
      path: '/energy-sourcing-and-contracts'
      fullPath: '/data-management/energy-sourcing-and-contracts'
      preLoaderRoute: typeof LayoutDataManagementEnergySourcingAndContractsImport
      parentRoute: typeof LayoutDataManagementImport
    }
    '/_layout/data-management/invoice-data': {
      id: '/_layout/data-management/invoice-data'
      path: '/invoice-data'
      fullPath: '/data-management/invoice-data'
      preLoaderRoute: typeof LayoutDataManagementInvoiceDataImport
      parentRoute: typeof LayoutDataManagementImport
    }
    '/_layout/invoices/$invoiceId': {
      id: '/_layout/invoices/$invoiceId'
      path: '/invoices/$invoiceId'
      fullPath: '/invoices/$invoiceId'
      preLoaderRoute: typeof LayoutInvoicesInvoiceIdImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/reporting/$reportId': {
      id: '/_layout/reporting/$reportId'
      path: '/reporting/$reportId'
      fullPath: '/reporting/$reportId'
      preLoaderRoute: typeof LayoutReportingReportIdImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/sustainability/electricity-mix-usage': {
      id: '/_layout/sustainability/electricity-mix-usage'
      path: '/electricity-mix-usage'
      fullPath: '/sustainability/electricity-mix-usage'
      preLoaderRoute: typeof LayoutSustainabilityElectricityMixUsageImport
      parentRoute: typeof LayoutSustainabilityImport
    }
    '/_layout/sustainability/ghg-emissions-report': {
      id: '/_layout/sustainability/ghg-emissions-report'
      path: '/ghg-emissions-report'
      fullPath: '/sustainability/ghg-emissions-report'
      preLoaderRoute: typeof LayoutSustainabilityGhgEmissionsReportImport
      parentRoute: typeof LayoutSustainabilityImport
    }
    '/_layout/sustainability/total-emissions': {
      id: '/_layout/sustainability/total-emissions'
      path: '/total-emissions'
      fullPath: '/sustainability/total-emissions'
      preLoaderRoute: typeof LayoutSustainabilityTotalEmissionsImport
      parentRoute: typeof LayoutSustainabilityImport
    }
    '/_layout/active-management/': {
      id: '/_layout/active-management/'
      path: '/'
      fullPath: '/active-management/'
      preLoaderRoute: typeof LayoutActiveManagementIndexImport
      parentRoute: typeof LayoutActiveManagementImport
    }
    '/_layout/analytics/': {
      id: '/_layout/analytics/'
      path: '/'
      fullPath: '/analytics/'
      preLoaderRoute: typeof LayoutAnalyticsIndexImport
      parentRoute: typeof LayoutAnalyticsImport
    }
    '/_layout/billing-and-payments/': {
      id: '/_layout/billing-and-payments/'
      path: '/'
      fullPath: '/billing-and-payments/'
      preLoaderRoute: typeof LayoutBillingAndPaymentsIndexImport
      parentRoute: typeof LayoutBillingAndPaymentsImport
    }
    '/_layout/data-management/': {
      id: '/_layout/data-management/'
      path: '/'
      fullPath: '/data-management/'
      preLoaderRoute: typeof LayoutDataManagementIndexImport
      parentRoute: typeof LayoutDataManagementImport
    }
    '/_layout/reporting/': {
      id: '/_layout/reporting/'
      path: '/reporting'
      fullPath: '/reporting'
      preLoaderRoute: typeof LayoutReportingIndexImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/sustainability/': {
      id: '/_layout/sustainability/'
      path: '/'
      fullPath: '/sustainability/'
      preLoaderRoute: typeof LayoutSustainabilityIndexImport
      parentRoute: typeof LayoutSustainabilityImport
    }
    '/_layout/reporting/$reportId/edit': {
      id: '/_layout/reporting/$reportId/edit'
      path: '/edit'
      fullPath: '/reporting/$reportId/edit'
      preLoaderRoute: typeof LayoutReportingReportIdEditImport
      parentRoute: typeof LayoutReportingReportIdImport
    }
    '/_layout/reporting/$reportId/': {
      id: '/_layout/reporting/$reportId/'
      path: '/'
      fullPath: '/reporting/$reportId/'
      preLoaderRoute: typeof LayoutReportingReportIdIndexImport
      parentRoute: typeof LayoutReportingReportIdImport
    }
  }
}

// Create and export the route tree

interface LayoutActiveManagementRouteChildren {
  LayoutActiveManagementActiveEnergyManagementRoute: typeof LayoutActiveManagementActiveEnergyManagementRoute
  LayoutActiveManagementIntervalRoute: typeof LayoutActiveManagementIntervalRoute
  LayoutActiveManagementIndexRoute: typeof LayoutActiveManagementIndexRoute
}

const LayoutActiveManagementRouteChildren: LayoutActiveManagementRouteChildren =
  {
    LayoutActiveManagementActiveEnergyManagementRoute:
      LayoutActiveManagementActiveEnergyManagementRoute,
    LayoutActiveManagementIntervalRoute: LayoutActiveManagementIntervalRoute,
    LayoutActiveManagementIndexRoute: LayoutActiveManagementIndexRoute,
  }

const LayoutActiveManagementRouteWithChildren =
  LayoutActiveManagementRoute._addFileChildren(
    LayoutActiveManagementRouteChildren,
  )

interface LayoutAnalyticsRouteChildren {
  LayoutAnalyticsBenchmarkingRoute: typeof LayoutAnalyticsBenchmarkingRoute
  LayoutAnalyticsUsageAndCostRoute: typeof LayoutAnalyticsUsageAndCostRoute
  LayoutAnalyticsIndexRoute: typeof LayoutAnalyticsIndexRoute
}

const LayoutAnalyticsRouteChildren: LayoutAnalyticsRouteChildren = {
  LayoutAnalyticsBenchmarkingRoute: LayoutAnalyticsBenchmarkingRoute,
  LayoutAnalyticsUsageAndCostRoute: LayoutAnalyticsUsageAndCostRoute,
  LayoutAnalyticsIndexRoute: LayoutAnalyticsIndexRoute,
}

const LayoutAnalyticsRouteWithChildren = LayoutAnalyticsRoute._addFileChildren(
  LayoutAnalyticsRouteChildren,
)

interface LayoutBillingAndPaymentsRouteChildren {
  LayoutBillingAndPaymentsPayablesSummaryRoute: typeof LayoutBillingAndPaymentsPayablesSummaryRoute
  LayoutBillingAndPaymentsIndexRoute: typeof LayoutBillingAndPaymentsIndexRoute
}

const LayoutBillingAndPaymentsRouteChildren: LayoutBillingAndPaymentsRouteChildren =
  {
    LayoutBillingAndPaymentsPayablesSummaryRoute:
      LayoutBillingAndPaymentsPayablesSummaryRoute,
    LayoutBillingAndPaymentsIndexRoute: LayoutBillingAndPaymentsIndexRoute,
  }

const LayoutBillingAndPaymentsRouteWithChildren =
  LayoutBillingAndPaymentsRoute._addFileChildren(
    LayoutBillingAndPaymentsRouteChildren,
  )

interface LayoutDataManagementRouteChildren {
  LayoutDataManagementEnergySourcingAndContractsRoute: typeof LayoutDataManagementEnergySourcingAndContractsRoute
  LayoutDataManagementInvoiceDataRoute: typeof LayoutDataManagementInvoiceDataRoute
  LayoutDataManagementIndexRoute: typeof LayoutDataManagementIndexRoute
}

const LayoutDataManagementRouteChildren: LayoutDataManagementRouteChildren = {
  LayoutDataManagementEnergySourcingAndContractsRoute:
    LayoutDataManagementEnergySourcingAndContractsRoute,
  LayoutDataManagementInvoiceDataRoute: LayoutDataManagementInvoiceDataRoute,
  LayoutDataManagementIndexRoute: LayoutDataManagementIndexRoute,
}

const LayoutDataManagementRouteWithChildren =
  LayoutDataManagementRoute._addFileChildren(LayoutDataManagementRouteChildren)

interface LayoutSustainabilityRouteChildren {
  LayoutSustainabilityElectricityMixUsageRoute: typeof LayoutSustainabilityElectricityMixUsageRoute
  LayoutSustainabilityGhgEmissionsReportRoute: typeof LayoutSustainabilityGhgEmissionsReportRoute
  LayoutSustainabilityTotalEmissionsRoute: typeof LayoutSustainabilityTotalEmissionsRoute
  LayoutSustainabilityIndexRoute: typeof LayoutSustainabilityIndexRoute
}

const LayoutSustainabilityRouteChildren: LayoutSustainabilityRouteChildren = {
  LayoutSustainabilityElectricityMixUsageRoute:
    LayoutSustainabilityElectricityMixUsageRoute,
  LayoutSustainabilityGhgEmissionsReportRoute:
    LayoutSustainabilityGhgEmissionsReportRoute,
  LayoutSustainabilityTotalEmissionsRoute:
    LayoutSustainabilityTotalEmissionsRoute,
  LayoutSustainabilityIndexRoute: LayoutSustainabilityIndexRoute,
}

const LayoutSustainabilityRouteWithChildren =
  LayoutSustainabilityRoute._addFileChildren(LayoutSustainabilityRouteChildren)

interface LayoutReportingReportIdRouteChildren {
  LayoutReportingReportIdEditRoute: typeof LayoutReportingReportIdEditRoute
  LayoutReportingReportIdIndexRoute: typeof LayoutReportingReportIdIndexRoute
}

const LayoutReportingReportIdRouteChildren: LayoutReportingReportIdRouteChildren =
  {
    LayoutReportingReportIdEditRoute: LayoutReportingReportIdEditRoute,
    LayoutReportingReportIdIndexRoute: LayoutReportingReportIdIndexRoute,
  }

const LayoutReportingReportIdRouteWithChildren =
  LayoutReportingReportIdRoute._addFileChildren(
    LayoutReportingReportIdRouteChildren,
  )

interface LayoutRouteChildren {
  LayoutActiveManagementRoute: typeof LayoutActiveManagementRouteWithChildren
  LayoutAnalyticsRoute: typeof LayoutAnalyticsRouteWithChildren
  LayoutBillingAndPaymentsRoute: typeof LayoutBillingAndPaymentsRouteWithChildren
  LayoutDashboardRoute: typeof LayoutDashboardRoute
  LayoutDataManagementRoute: typeof LayoutDataManagementRouteWithChildren
  LayoutSustainabilityRoute: typeof LayoutSustainabilityRouteWithChildren
  LayoutInvoicesInvoiceIdRoute: typeof LayoutInvoicesInvoiceIdRoute
  LayoutReportingReportIdRoute: typeof LayoutReportingReportIdRouteWithChildren
  LayoutReportingIndexRoute: typeof LayoutReportingIndexRoute
}

const LayoutRouteChildren: LayoutRouteChildren = {
  LayoutActiveManagementRoute: LayoutActiveManagementRouteWithChildren,
  LayoutAnalyticsRoute: LayoutAnalyticsRouteWithChildren,
  LayoutBillingAndPaymentsRoute: LayoutBillingAndPaymentsRouteWithChildren,
  LayoutDashboardRoute: LayoutDashboardRoute,
  LayoutDataManagementRoute: LayoutDataManagementRouteWithChildren,
  LayoutSustainabilityRoute: LayoutSustainabilityRouteWithChildren,
  LayoutInvoicesInvoiceIdRoute: LayoutInvoicesInvoiceIdRoute,
  LayoutReportingReportIdRoute: LayoutReportingReportIdRouteWithChildren,
  LayoutReportingIndexRoute: LayoutReportingIndexRoute,
}

const LayoutRouteWithChildren =
  LayoutRoute._addFileChildren(LayoutRouteChildren)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '': typeof LayoutRouteWithChildren
  '/active-management': typeof LayoutActiveManagementRouteWithChildren
  '/analytics': typeof LayoutAnalyticsRouteWithChildren
  '/billing-and-payments': typeof LayoutBillingAndPaymentsRouteWithChildren
  '/dashboard': typeof LayoutDashboardRoute
  '/data-management': typeof LayoutDataManagementRouteWithChildren
  '/sustainability': typeof LayoutSustainabilityRouteWithChildren
  '/login': typeof LoginIndexRoute
  '/active-management/active-energy-management': typeof LayoutActiveManagementActiveEnergyManagementRoute
  '/active-management/interval': typeof LayoutActiveManagementIntervalRoute
  '/analytics/benchmarking': typeof LayoutAnalyticsBenchmarkingRoute
  '/analytics/usage-and-cost': typeof LayoutAnalyticsUsageAndCostRoute
  '/billing-and-payments/payables-summary': typeof LayoutBillingAndPaymentsPayablesSummaryRoute
  '/data-management/energy-sourcing-and-contracts': typeof LayoutDataManagementEnergySourcingAndContractsRoute
  '/data-management/invoice-data': typeof LayoutDataManagementInvoiceDataRoute
  '/invoices/$invoiceId': typeof LayoutInvoicesInvoiceIdRoute
  '/reporting/$reportId': typeof LayoutReportingReportIdRouteWithChildren
  '/sustainability/electricity-mix-usage': typeof LayoutSustainabilityElectricityMixUsageRoute
  '/sustainability/ghg-emissions-report': typeof LayoutSustainabilityGhgEmissionsReportRoute
  '/sustainability/total-emissions': typeof LayoutSustainabilityTotalEmissionsRoute
  '/active-management/': typeof LayoutActiveManagementIndexRoute
  '/analytics/': typeof LayoutAnalyticsIndexRoute
  '/billing-and-payments/': typeof LayoutBillingAndPaymentsIndexRoute
  '/data-management/': typeof LayoutDataManagementIndexRoute
  '/reporting': typeof LayoutReportingIndexRoute
  '/sustainability/': typeof LayoutSustainabilityIndexRoute
  '/reporting/$reportId/edit': typeof LayoutReportingReportIdEditRoute
  '/reporting/$reportId/': typeof LayoutReportingReportIdIndexRoute
}

export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '': typeof LayoutRouteWithChildren
  '/dashboard': typeof LayoutDashboardRoute
  '/login': typeof LoginIndexRoute
  '/active-management/active-energy-management': typeof LayoutActiveManagementActiveEnergyManagementRoute
  '/active-management/interval': typeof LayoutActiveManagementIntervalRoute
  '/analytics/benchmarking': typeof LayoutAnalyticsBenchmarkingRoute
  '/analytics/usage-and-cost': typeof LayoutAnalyticsUsageAndCostRoute
  '/billing-and-payments/payables-summary': typeof LayoutBillingAndPaymentsPayablesSummaryRoute
  '/data-management/energy-sourcing-and-contracts': typeof LayoutDataManagementEnergySourcingAndContractsRoute
  '/data-management/invoice-data': typeof LayoutDataManagementInvoiceDataRoute
  '/invoices/$invoiceId': typeof LayoutInvoicesInvoiceIdRoute
  '/sustainability/electricity-mix-usage': typeof LayoutSustainabilityElectricityMixUsageRoute
  '/sustainability/ghg-emissions-report': typeof LayoutSustainabilityGhgEmissionsReportRoute
  '/sustainability/total-emissions': typeof LayoutSustainabilityTotalEmissionsRoute
  '/active-management': typeof LayoutActiveManagementIndexRoute
  '/analytics': typeof LayoutAnalyticsIndexRoute
  '/billing-and-payments': typeof LayoutBillingAndPaymentsIndexRoute
  '/data-management': typeof LayoutDataManagementIndexRoute
  '/reporting': typeof LayoutReportingIndexRoute
  '/sustainability': typeof LayoutSustainabilityIndexRoute
  '/reporting/$reportId/edit': typeof LayoutReportingReportIdEditRoute
  '/reporting/$reportId': typeof LayoutReportingReportIdIndexRoute
}

export interface FileRoutesById {
  __root__: typeof rootRoute
  '/': typeof IndexRoute
  '/_layout': typeof LayoutRouteWithChildren
  '/_layout/active-management': typeof LayoutActiveManagementRouteWithChildren
  '/_layout/analytics': typeof LayoutAnalyticsRouteWithChildren
  '/_layout/billing-and-payments': typeof LayoutBillingAndPaymentsRouteWithChildren
  '/_layout/dashboard': typeof LayoutDashboardRoute
  '/_layout/data-management': typeof LayoutDataManagementRouteWithChildren
  '/_layout/sustainability': typeof LayoutSustainabilityRouteWithChildren
  '/login/': typeof LoginIndexRoute
  '/_layout/active-management/active-energy-management': typeof LayoutActiveManagementActiveEnergyManagementRoute
  '/_layout/active-management/interval': typeof LayoutActiveManagementIntervalRoute
  '/_layout/analytics/benchmarking': typeof LayoutAnalyticsBenchmarkingRoute
  '/_layout/analytics/usage-and-cost': typeof LayoutAnalyticsUsageAndCostRoute
  '/_layout/billing-and-payments/payables-summary': typeof LayoutBillingAndPaymentsPayablesSummaryRoute
  '/_layout/data-management/energy-sourcing-and-contracts': typeof LayoutDataManagementEnergySourcingAndContractsRoute
  '/_layout/data-management/invoice-data': typeof LayoutDataManagementInvoiceDataRoute
  '/_layout/invoices/$invoiceId': typeof LayoutInvoicesInvoiceIdRoute
  '/_layout/reporting/$reportId': typeof LayoutReportingReportIdRouteWithChildren
  '/_layout/sustainability/electricity-mix-usage': typeof LayoutSustainabilityElectricityMixUsageRoute
  '/_layout/sustainability/ghg-emissions-report': typeof LayoutSustainabilityGhgEmissionsReportRoute
  '/_layout/sustainability/total-emissions': typeof LayoutSustainabilityTotalEmissionsRoute
  '/_layout/active-management/': typeof LayoutActiveManagementIndexRoute
  '/_layout/analytics/': typeof LayoutAnalyticsIndexRoute
  '/_layout/billing-and-payments/': typeof LayoutBillingAndPaymentsIndexRoute
  '/_layout/data-management/': typeof LayoutDataManagementIndexRoute
  '/_layout/reporting/': typeof LayoutReportingIndexRoute
  '/_layout/sustainability/': typeof LayoutSustainabilityIndexRoute
  '/_layout/reporting/$reportId/edit': typeof LayoutReportingReportIdEditRoute
  '/_layout/reporting/$reportId/': typeof LayoutReportingReportIdIndexRoute
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | ''
    | '/active-management'
    | '/analytics'
    | '/billing-and-payments'
    | '/dashboard'
    | '/data-management'
    | '/sustainability'
    | '/login'
    | '/active-management/active-energy-management'
    | '/active-management/interval'
    | '/analytics/benchmarking'
    | '/analytics/usage-and-cost'
    | '/billing-and-payments/payables-summary'
    | '/data-management/energy-sourcing-and-contracts'
    | '/data-management/invoice-data'
    | '/invoices/$invoiceId'
    | '/reporting/$reportId'
    | '/sustainability/electricity-mix-usage'
    | '/sustainability/ghg-emissions-report'
    | '/sustainability/total-emissions'
    | '/active-management/'
    | '/analytics/'
    | '/billing-and-payments/'
    | '/data-management/'
    | '/reporting'
    | '/sustainability/'
    | '/reporting/$reportId/edit'
    | '/reporting/$reportId/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | ''
    | '/dashboard'
    | '/login'
    | '/active-management/active-energy-management'
    | '/active-management/interval'
    | '/analytics/benchmarking'
    | '/analytics/usage-and-cost'
    | '/billing-and-payments/payables-summary'
    | '/data-management/energy-sourcing-and-contracts'
    | '/data-management/invoice-data'
    | '/invoices/$invoiceId'
    | '/sustainability/electricity-mix-usage'
    | '/sustainability/ghg-emissions-report'
    | '/sustainability/total-emissions'
    | '/active-management'
    | '/analytics'
    | '/billing-and-payments'
    | '/data-management'
    | '/reporting'
    | '/sustainability'
    | '/reporting/$reportId/edit'
    | '/reporting/$reportId'
  id:
    | '__root__'
    | '/'
    | '/_layout'
    | '/_layout/active-management'
    | '/_layout/analytics'
    | '/_layout/billing-and-payments'
    | '/_layout/dashboard'
    | '/_layout/data-management'
    | '/_layout/sustainability'
    | '/login/'
    | '/_layout/active-management/active-energy-management'
    | '/_layout/active-management/interval'
    | '/_layout/analytics/benchmarking'
    | '/_layout/analytics/usage-and-cost'
    | '/_layout/billing-and-payments/payables-summary'
    | '/_layout/data-management/energy-sourcing-and-contracts'
    | '/_layout/data-management/invoice-data'
    | '/_layout/invoices/$invoiceId'
    | '/_layout/reporting/$reportId'
    | '/_layout/sustainability/electricity-mix-usage'
    | '/_layout/sustainability/ghg-emissions-report'
    | '/_layout/sustainability/total-emissions'
    | '/_layout/active-management/'
    | '/_layout/analytics/'
    | '/_layout/billing-and-payments/'
    | '/_layout/data-management/'
    | '/_layout/reporting/'
    | '/_layout/sustainability/'
    | '/_layout/reporting/$reportId/edit'
    | '/_layout/reporting/$reportId/'
  fileRoutesById: FileRoutesById
}

export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  LayoutRoute: typeof LayoutRouteWithChildren
  LoginIndexRoute: typeof LoginIndexRoute
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  LayoutRoute: LayoutRouteWithChildren,
  LoginIndexRoute: LoginIndexRoute,
}

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/",
        "/_layout",
        "/login/"
      ]
    },
    "/": {
      "filePath": "index.tsx"
    },
    "/_layout": {
      "filePath": "_layout.tsx",
      "children": [
        "/_layout/active-management",
        "/_layout/analytics",
        "/_layout/billing-and-payments",
        "/_layout/dashboard",
        "/_layout/data-management",
        "/_layout/sustainability",
        "/_layout/invoices/$invoiceId",
        "/_layout/reporting/$reportId",
        "/_layout/reporting/"
      ]
    },
    "/_layout/active-management": {
      "filePath": "_layout/active-management.tsx",
      "parent": "/_layout",
      "children": [
        "/_layout/active-management/active-energy-management",
        "/_layout/active-management/interval",
        "/_layout/active-management/"
      ]
    },
    "/_layout/analytics": {
      "filePath": "_layout/analytics.tsx",
      "parent": "/_layout",
      "children": [
        "/_layout/analytics/benchmarking",
        "/_layout/analytics/usage-and-cost",
        "/_layout/analytics/"
      ]
    },
    "/_layout/billing-and-payments": {
      "filePath": "_layout/billing-and-payments.tsx",
      "parent": "/_layout",
      "children": [
        "/_layout/billing-and-payments/payables-summary",
        "/_layout/billing-and-payments/"
      ]
    },
    "/_layout/dashboard": {
      "filePath": "_layout/dashboard.tsx",
      "parent": "/_layout"
    },
    "/_layout/data-management": {
      "filePath": "_layout/data-management.tsx",
      "parent": "/_layout",
      "children": [
        "/_layout/data-management/energy-sourcing-and-contracts",
        "/_layout/data-management/invoice-data",
        "/_layout/data-management/"
      ]
    },
    "/_layout/sustainability": {
      "filePath": "_layout/sustainability.tsx",
      "parent": "/_layout",
      "children": [
        "/_layout/sustainability/electricity-mix-usage",
        "/_layout/sustainability/ghg-emissions-report",
        "/_layout/sustainability/total-emissions",
        "/_layout/sustainability/"
      ]
    },
    "/login/": {
      "filePath": "login/index.tsx"
    },
    "/_layout/active-management/active-energy-management": {
      "filePath": "_layout/active-management/active-energy-management.tsx",
      "parent": "/_layout/active-management"
    },
    "/_layout/active-management/interval": {
      "filePath": "_layout/active-management/interval.tsx",
      "parent": "/_layout/active-management"
    },
    "/_layout/analytics/benchmarking": {
      "filePath": "_layout/analytics/benchmarking.tsx",
      "parent": "/_layout/analytics"
    },
    "/_layout/analytics/usage-and-cost": {
      "filePath": "_layout/analytics/usage-and-cost.tsx",
      "parent": "/_layout/analytics"
    },
    "/_layout/billing-and-payments/payables-summary": {
      "filePath": "_layout/billing-and-payments/payables-summary.tsx",
      "parent": "/_layout/billing-and-payments"
    },
    "/_layout/data-management/energy-sourcing-and-contracts": {
      "filePath": "_layout/data-management/energy-sourcing-and-contracts.tsx",
      "parent": "/_layout/data-management"
    },
    "/_layout/data-management/invoice-data": {
      "filePath": "_layout/data-management/invoice-data.tsx",
      "parent": "/_layout/data-management"
    },
    "/_layout/invoices/$invoiceId": {
      "filePath": "_layout/invoices.$invoiceId.tsx",
      "parent": "/_layout"
    },
    "/_layout/reporting/$reportId": {
      "filePath": "_layout/reporting/$reportId.tsx",
      "parent": "/_layout",
      "children": [
        "/_layout/reporting/$reportId/edit",
        "/_layout/reporting/$reportId/"
      ]
    },
    "/_layout/sustainability/electricity-mix-usage": {
      "filePath": "_layout/sustainability/electricity-mix-usage.tsx",
      "parent": "/_layout/sustainability"
    },
    "/_layout/sustainability/ghg-emissions-report": {
      "filePath": "_layout/sustainability/ghg-emissions-report.tsx",
      "parent": "/_layout/sustainability"
    },
    "/_layout/sustainability/total-emissions": {
      "filePath": "_layout/sustainability/total-emissions.tsx",
      "parent": "/_layout/sustainability"
    },
    "/_layout/active-management/": {
      "filePath": "_layout/active-management/index.tsx",
      "parent": "/_layout/active-management"
    },
    "/_layout/analytics/": {
      "filePath": "_layout/analytics/index.tsx",
      "parent": "/_layout/analytics"
    },
    "/_layout/billing-and-payments/": {
      "filePath": "_layout/billing-and-payments/index.tsx",
      "parent": "/_layout/billing-and-payments"
    },
    "/_layout/data-management/": {
      "filePath": "_layout/data-management/index.tsx",
      "parent": "/_layout/data-management"
    },
    "/_layout/reporting/": {
      "filePath": "_layout/reporting/index.tsx",
      "parent": "/_layout"
    },
    "/_layout/sustainability/": {
      "filePath": "_layout/sustainability/index.tsx",
      "parent": "/_layout/sustainability"
    },
    "/_layout/reporting/$reportId/edit": {
      "filePath": "_layout/reporting/$reportId/edit.tsx",
      "parent": "/_layout/reporting/$reportId"
    },
    "/_layout/reporting/$reportId/": {
      "filePath": "_layout/reporting/$reportId/index.tsx",
      "parent": "/_layout/reporting/$reportId"
    }
  }
}
ROUTE_MANIFEST_END */
